export const HREmployeeData = [
    {
      id: "KCVF1555",
      fName: "Donald",
      designation:'Digital Marketing',
      dept: `Marketing`,
      type: 'Permanent',
      joinDate: '28-06-2022',
      shiftTime: 'Shift A',
      contact : 9855254618
    },
    {
        id: "KCVF99999",
        fName: "Sonal",
        designation:'Content Writing',
        dept: `Design`,
        type: 'Part time',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1234L",
        fName: "John Doe",
        designation:'Social Media Manager',
        dept: `Sales`,
        type: 'Temporary',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF13456L",
        fName: "John Doe",
        designation:'Lead designer',
        dept: `Design`,
        type: 'Contractual',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF134567L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF2134L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF5347L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1328L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF13L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
      {
        id: "KCVF1342L",
        fName: "John Doe",
        designation:'Digital Marketing',
        dept: `Testing`,
        type: 'Permanent',
        joinDate: '28-06-2022',
        shiftTime: 'Shift A',
        contact : 9855254618
      },
  ];